import { useContext, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import GlobalContext from '../../contexts/index';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import './style.scss';

const Sidebar = () => {
  const navigate = useNavigate();
  const { entity, id } = useParams();
  const { link, setLink, currentUser, menuData, setOpenDrawer } =
    useContext(GlobalContext);

  const [expanded, setExpanded] = useState(entity);
  const handleChange = (panel) => (event, newExpanded) => {
    setOpenDrawer(false);
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div className="side-bar">
      {currentUser &&
        menuData?.map((item, key) => {
          if (item.link?.rules?.indexOf(currentUser.role?.name) > -1)
            return (
              <Accordion
                expanded={expanded === item.link.key}
                onChange={handleChange(item.link.key)}
                key={key}
                classes={{
                  root: 'accordionRoot',
                  expanded: 'accordionExpanded'
                }}
              >
                <AccordionSummary
                  classes={{
                    root: 'accordionSummaryRoot',
                    content: 'accordionSummaryContent',
                    expanded: 'accordionSummaryExpanded'
                  }}
                >
                  <div
                    className={`menu-label ${
                      item?.link?.key === entity ? 'active' : ''
                    }`}
                    onClick={() => {
                      setLink(item.link.view);
                      navigate(`/${item?.link?.key}`);
                    }}
                  >
                    {item?.link?.value}
                  </div>
                </AccordionSummary>
                {item.children?.map((child, keyChild) => {
                  if (child.link?.rules?.indexOf(currentUser.role?.name) > -1)
                    if (
                      (child.link.view === 'view' &&
                        entity === child.link.key &&
                        id) ||
                      child.link.view !== 'view'
                    ) {
                      return (
                        <AccordionDetails
                          key={`${key}-${keyChild}`}
                          classes={{ root: 'accordionChild' }}
                        >
                          <div
                            className={`menu-label ${
                              (child.link.view === 'view' &&
                                entity === child.link.key &&
                                id) ||
                              (child?.link?.key === entity &&
                                link === child.link.view &&
                                !id) ||
                              child.link.key === `${entity}/${id}`
                                ? 'active'
                                : ''
                            }`}
                            onClick={() => {
                              setLink(child.link.view);
                              navigate(`/${child?.link?.key}`);
                            }}
                          >
                            {child?.link?.value}
                          </div>
                        </AccordionDetails>
                      );
                    }
                })}
              </Accordion>
            );
        })}
    </div>
  );
};

export default Sidebar;
